<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g fill="none" fill-rule="evenodd">
            <g>
                <g transform="translate(-92 -168) translate(93 169)">
                    <ellipse cx="8" cy="8.014" fill="#2D3E4F" stroke="#2D3E4F" rx="8" ry="8.014"/>
                    <g fill-rule="nonzero" stroke="#FFF" stroke-linecap="round">
                        <path d="M0 0L5.834 5.834M0 5.834L5.834 0" transform="translate(5 5)"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'cancel-icon'
}
</script>
